import script from "./group-fieldset-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./group-fieldset-component.vue?vue&type=script&setup=true&lang=ts"

import "./group-fieldset-component.vue?vue&type=style&index=0&id=1aa043d9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa043d9"]])

export default __exports__